import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalComponent } from './modal/modal.component';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SpinnerComponent } from './spinner/spinner.component';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { ModalErrorComponent } from './modal-error/modal-error.component';
import { ModalClassificacaoComponent } from './modal-classificacao/modal-classificacao.component';
import { ModalOverlayMapLinkComponent } from './modal-overlay-map-link/modal-overlay-map-link.component';
import { SelectInputComponent } from './select-input/select-input.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ModalFileComponent } from './modal-file/modal-file.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CarrosselComponent } from './carrossel/carrossel.component';
import { SelectFilterInputComponent } from './select-filter-input/select-filter-input.component';
import { GoogleTranslateComponent } from './google-translate/google-translate.component';
import { AiChatFloatingComponent } from './ai-chat-floating/ai-chat-floating.component';
import { AiChatIntegratedComponent } from './ai-chat-integrated/ai-chat-integrated.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    ModalComponent,
    SpinnerComponent,
    ModalConfirmComponent,
    ModalErrorComponent,
    ModalClassificacaoComponent,
    ModalOverlayMapLinkComponent,
    SelectInputComponent,
    ModalFileComponent,
    CarrosselComponent,
    SelectFilterInputComponent,
    GoogleTranslateComponent,
    AiChatFloatingComponent,
    AiChatIntegratedComponent
  ],
  imports: [
    MatSlideToggleModule,
    RouterModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    NgxMaskModule.forRoot(maskConfig),
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    ReactiveFormsModule
  ],
  exports: [
    SidebarComponent,
    HeaderComponent,
    ModalComponent,
    SpinnerComponent,
    SelectInputComponent,
    CarrosselComponent,
    SelectFilterInputComponent,
    GoogleTranslateComponent,
    AiChatFloatingComponent,
    AiChatIntegratedComponent,
  ]
})
export class ComponentsModule { }
